export default [
    {
        text: "Receita de Venda de Energia Elétrica - Fornecimento (Venda para PPA)",
        value: "ReceitaVendaPPA",
    },
    {
        text: "Receita de Venda de Energia Elétrica - Fornecimento (Venda de Lastro)",
        value: "ReceitaVendaLastro"
    },
    {
        text: "Receita de Venda de Energia Elétrica - Fornecimento (Mercado Externo) (não incide PIS / COFINS)",
        value: "ReceitaMercadoExterno"
    },
    {
        text: "Receita de Venda de Energia Elétrica - Suprimento Curto Prazo - CCEE",
        value: "ReceitaSuprimentoCurtoPrazo"
    },
    {
        text: "Receita de Venda de Energia Elétrica - Fornecimento (Exportação) (não incide PIS/ COFINS)",
        value: "ReceitaVendaEnergiaEletricaFornecimentoExportacao"
    },
    {
        text: "Serviços Taxados",
        value: "ServicosTaxados"
    },
    {
        text: "Outras Receitas",
        value: "OutrasReceitas"
    },
]